module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/beauty-pass-white-tier-015a0c6d8b3fb4418ef668f140889773.png";